import axios from 'axios';
import auth from '../auth';

const mediaStoreUrl = process.env.KMB_MEDIA_STORE_URL;
const getConfig = () => ({
  'Content-Type': 'multipart/form-data',
  headers: {
    Authorization: `Bearer ${auth.token.get()}`,
  },
});

const upload = (file) => {
  const formData = new FormData();
  formData.append('file', file);

  return axios.post(`${mediaStoreUrl}/v1/medias`, formData, getConfig());
};

export default {
  upload,
};



// WEBPACK FOOTER //
// ./src/helpers/request/media.js